export type UserStatus = 'Account Created' | 'Setup Pending'

export interface UserRow {
	company: string
	id: number
	licenseExpiration: string
	userEmail: string
	userName: string
	userRole: string
	userStatus: UserStatus
}

export const adminDummyData: UserRow[] = [
	{
		id: 1,
		company: 'IDEO',
		userName: 'John Doe',
		userEmail: 'john@ideo.com',
		userStatus: 'Account Created',
		userRole: 'Facilitator',
		licenseExpiration: 'Never',
	},
	{
		id: 2,
		company: 'BCG',
		userName: 'Jane Doe',
		userEmail: 'jane@bcg.com',
		userStatus: 'Account Created',
		userRole: 'Facilitator',
		licenseExpiration: 'Never',
	},
	{
		id: 3,
		company: 'Nike',
		userName: 'James Doe',
		userEmail: 'James@nike.com',
		userStatus: 'Setup Pending',
		userRole: 'Facilitator',
		licenseExpiration: 'Never',
	},
	{
		id: 4,
		company: 'IBM',
		userName: 'Janet Doe',
		userEmail: 'Janet@IBM.com',
		userStatus: 'Setup Pending',
		userRole: 'Participant',
		licenseExpiration: 'Never',
	},
	{
		id: 5,
		company: 'Delta',
		userName: 'Jerome Doe',
		userEmail: 'Jerome@delta.com',
		userStatus: 'Setup Pending',
		userRole: 'Participant',
		licenseExpiration: '9/8/25',
	},
	{
		id: 6,
		company: 'Apple',
		userName: 'Janice Doe',
		userEmail: 'Janice@apple.com',
		userStatus: 'Setup Pending',
		userRole: 'Participant',
		licenseExpiration: '10/10/26',
	},
	{
		id: 7,
		company: 'Slalom Consulting',
		userName: 'Jake Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Super-User',
		licenseExpiration: 'Never',
	},
	{
		id: 8,
		company: 'Slalom Consulting',
		userName: 'Jake Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Super-User',
		licenseExpiration: 'Never',
	},
	{
		id: 9,
		company: 'Slalom Consulting',
		userName: 'Jake Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Super-User',
		licenseExpiration: 'Never',
	},
	{
		id: 10,
		company: 'Slalom Consulting',
		userName: 'Jake Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Super-User',
		licenseExpiration: 'Never',
	},
	{
		id: 11,
		company: 'Slalom Consulting',
		userName: 'Jake Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Super-User',
		licenseExpiration: 'Never',
	},
	{
		id: 12,
		company: 'Slalom Consulting',
		userName: 'Jake Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Super-User',
		licenseExpiration: 'Never',
	},
	{
		id: 13,
		company: 'Slalom Consulting',
		userName: 'Jake Doe',
		userEmail: 'Jake@slalom.com',
		userStatus: 'Account Created',
		userRole: 'Super-User',
		licenseExpiration: 'Never',
	},
]
